module.exports = __webpack_public_path__ + "img/bv.00b582c2.jpg";